module.exports = {
	"base": {
		"welcome": "Välkommen till Mulligans, %{name}!",
		"user": "Användarinformation",
		"devices": "Enheter",
		"refunds": "Återbetalningar",
		"resources": "Resurser",
		"transactions": "Beställningar & Returer",
		"email": "E-post",
		"password": "Lösenord",
		"save": "Spara",
		"sign-out": "Logga ut",
		"cancel": "Avbryt",
		"close": "Stäng",
		"learn-more": "Läs mer",
		"required": "Krävs",
		"support": "Support",
		"bookshelf": "Bokhylla",
		"launch": "Starta",
		"download": "Hämta",
		"details": "Information",
		"cannot-be-blank": "%{field} får inte vara tomt.",
		"saving": "Sparar...",
		"done": "Klar",
		"failed": "Misslyckades",
		"copy": "Kopiera"
	},
	"signin": {
		"login-failure": "E-postadress eller lösenord är felaktigt",
		"welcome-large": "Välkommen till <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Logga in",
		"forgot-password": "Glömt ditt lösenord?",
		"new-to-vst": "Nyss upptäckt %{brand}?",
		"create-account": "Skapa ett konto",
		"signing-in": "Loggar in ...",
		"signin-failed": "Inloggning misslyckades"
	},
	"transactions": {
		"price": "Pris",
		"excluded": "(Exklusive skatt)",
		"quantity": "Kvantitet",
		"confirmation#": "Bekräftelsenummer",
		"payment": "Betalning",
		"purchased": "Inköpt",
		"purchase-details": "Inköpsinformation",
		"subtotal": "Delsumma",
		"total": "Totalt",
		"tax": "Skatt",
		"loading": "Hallå där, vi läser in dina transaktioner ...",
		"no-purchases": "Du har inga inköp.",
		"seller-vat": "Säljarmoms",
		"total-vat": "Totalt %{vat} betalt",
		"portion": "%{subTax} Skatt %{rate}%",
		"vat-disclosure": "Priset inkluderar %{vat}",
		"purchases": "Inköp",
		"refunded-items": "Återbetalning för artiklar",
		"book-title": "Boktitel",
		"refund-details": "Återbetalningsuppgifter",
		"print-receipt": "Skriv ut kvitto",
		"request-refund": "Begär återbetalning",
		"expired": "Har upphört att gälla",
		"expires-in": "Utgår %{date}",
		"details-refund": "Detaljer och återbetalning",
		"modal": {
			"cant-refund-title": "Återbetalning görs ej",
			"cant-refund": "Din bok medger ej återbetalning på grund av ett eller fler av följande skäl.",
			"cant-refund-1": "För mycket av innehållet i din bok har visats.",
			"cant-refund-2": "Det har gått mer än 14 dagar sedan inköpsdatum.",
			"cant-refund-3": "Dina onlineresurskod har visats.",
			"cant-refund-4": "Din bok har tidigare återbetalats.",
			"cant-refund-5": "Alla koder har redan lösts in och/eller återbetalats.",
			"cant-refund-6": "Det har gått mer än 30 dagar sedan inköpsdatum.",
			"cant-refund-support": "Om du fortfarande är osäker på återbetalningspolicyn för %{brand}, kan du kontakta <a href='%{support_url}' target='_blank'>support</a>."
		},
		"license": {
			"perpetual": "Onlineåtkomst utgår ej",
			"days": "%{days} dagars åtkomst"
		}
	},
	"devices": {
		"description": "%{brand} låter dig ha <span>%{desktop}-</span> datorer och <span>%{mobile}</span> mobila enheter som aktiveras när som helst.",
		"loading": "Hej, vi kan se dina enheter:)",
		"no-active": "Du har inga aktiva enheter.",
		"deactivate": "Inaktivera"
	},
	"user": {
		"personal-information": "Personuppgifter",
		"security-information": "Säkerhetsinformation",
		"notifications": "Aviseringar",
		"first-name": "Förnamn",
		"last-name": "Efternamn",
		"change-password-title": "Byt lösenord",
		"current-password": "Aktuellt lösenord",
		"new-password": "Nytt lösenord",
		"security-password": "Lösenord",
		"confirm-new-password": "Bekräfta nytt lösenord",
		"security-question": "Säkerhetsfråga:",
		"security-info-change": "Ändra",
		"question": "Fråga",
		"answer": "Svar",
		"notifications-text": "E-posta mig sporadiska uppdateringar om min kontoaktivitet, produktuppdateringar och specialerbjudanden.",
		"loading": "Spot tar reda på dina användaruppgifter, så dröj en sekund 🐶",
		"change-password-text": "Lösenordet måste ha en längd på minst åtta tecken och innehålla minst en stor bokstav, en liten bokstav och ett specialtecken.",
		"email-locked": "E-post låst",
		"email-locked-description": "Du har inte tillgång så att du kan ändra din e-postadress.",
		"email-locked-more": "Vänligen kontakta din administratör.",
		"security-question6": "Vilken är din favoritsport?",
		"security-question7": "Vilken är din favoritsmak för glass?",
		"security-question8": "Vad heter ditt favorithusdjur?",
		"security-question9": "Vad ville du bli när du blev stor, när du var liten?",
		"security-question10": "Vilket efternamn hade din favoritlärare?",
		"new-password-failure": "Lösenordet uppfyller inte kraven",
		"confirm-password-failure": "Lösenorden måste vara lika",
		"new-password-tooltip": "Måste ha en längd på minst åtta tecken och innehålla minst en stor bokstav, en liten bokstav och ett specialtecken.",
		"enter-valid-email": "Ange en giltig e-postadress.",
		"password-cannot-be-same": "Lösenordet får inte vara samma som tidigare lösenord",
		"incorrect-password": "Ogiltigt lösenord",
		"complete-account": "Det ser ut som om du behöver <a href='%{href}'>färdigställa ditt konto</a>.",
		"completing-allows": "När du har färdigställt ditt konto kan du läsa böcker offline på våra mobila appar och dela anteckningar och markeringar med vänner.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "tillbehör",
		"access-codes": "Åtkomstkoder",
		"print-on-demand": "Skriv ut på begäran",
		"check-pod": "Kontrollera utgivarens utskriftsalternativ för dina böcker.",
		"check-now": "Kontrollera nu",
		"loading": "Häng kvar medan vi uppdaterar dina resurser!",
		"in": "i",
		"access-code-intro": "En åtkomstkod är ett lösenord som du använder för att komma åt kursinnehåll online. När du har visat en kod för ett objekt, kommer du inte att kunna lämna tillbaka den. För ytterligare information om hur du använder dina åtkomstkoder, kan du besöka <a href='%{support_url}' target='_blank'>support</a>.",
		"expires": "Utgår",
		"expiration-message": "Innehåller instruktioner om hur du använder din åtkomstkod.",
		"copy-fail": "Det går inte att kopiera. Markera koden och kopiera den manuellt.",
		"launch-site": "Starta webbplats",
		"launch-book": "Starta bok",
		"reveal-code": "Visa kod",
		"no-resources": "Du har inga resurser.",
		"no-access-codes": "Du har inga åtkomstkoder.",
		"no-ancillaries": "Ingen hjälputrustning för denna titel",
		"name": "Namn",
		"type": "Typ",
		"size": "Storlek",
		"download-all": "Ladda ner allt",
		"back": "Tillbaka till resurser"
	},
	"refunds": {
		"states": {
			"refunded": "Återbetald",
			"unavailable": "Återbetalning görs ej"
		},
		"reasons": {
			"dropped": "Jag avslutade kursen",
			"wrong": "Detta var fel bok för min kurs",
			"print": "Jag bestämde mig för att köpa ett tryckt exemplar i stället",
			"missing": "Boken innehåller inte allt jag behöver för min kurs (t.ex. en CD, webbåtkomst, videoklipp)",
			"other": "Övrigt"
		},
		"bulk": {
			"policy": "Genom att klicka på knappen &quot;fullständig återbetalning&quot; nedan, samtycker jag till %{brand}s <a href='%{policy_url}' target='_blank'>återbetalningspolicy </a>.",
			"complete": "Fullständig återbetalning",
			"view-details": "Visa återbetalningsuppgifter",
			"success": "Din återbetalning har begärts. Vänta i 48 timmar på att den behandlas.",
			"failure": "Hoppsan! Något gick fel! Tyvärr gick din återbetalning inte igenom.",
			"retry": "Försök igen",
			"support": "Kontakta support",
			"available-codes": "Tillgängliga koder",
			"codes-selected": "Valda koder",
			"download": "Ladda ner koder",
			"partially-refunded": "Delvis återbetalad",
			"pick-one": "Du måste välja minst en kod för att göra en återbetalning"
		},
		"refund": "Återbetalning",
		"all": "Återbetala alla?",
		"missing-reason": "Du måste välja en orsak för att fortsätta",
		"missing-elaboration": "Förklara närmare",
		"policy": "Genom att klicka på knappen \"Slutför återbetalningsbegäran\" nedan, är jag införstådd med att om jag köper denna e-textbok från %{brand} på nytt, kan jag inte begära ytterligare återbetalningar för samma e-textbok. Visa fullständig returpolicy.",
		"refunded": "Åtebetald",
		"sorry": "Vi beklagar att du inte var nöjd med ditt köp.",
		"error": "Något gick fel",
		"error-explain": "Vi kunde inte bearbeta din återbetalning. Försök igen.",
		"why": "Vill du berätta varför?",
		"no-refunds": "Du har inga artiklar för återbetalning.",
		"select-codes": "Välj kod(er) att återbetala:",
		"number": "Hur många?",
		"back": "Tillbaka till återbetalningar"
	},
	"purchases": {
		"back": "Tillbaka till inköp"
	},
	"global-bar": {
		"account": "Kontoinställningar"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/sv.json
 ** module id = 1023
 ** module chunks = 0
 **/